export default __webpack_public_path__ + "static/media/polimorphic_shape_light_blue.d0ba348b.svg";